/* RESPONSIBLE TEAM: team-data-foundations */
import Model, { attr } from '@ember-data/model';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

/* See app/services/data_deletion_service/models/conversation_deletion_schedule.rb for state values */
enum State {
  Active = 'active',
  Paused = 'paused',
}

export default class ConversationDeletionSchedule extends Model {
  @service intl!: IntlService;

  @attr('number') declare retentionDays: number;
  @attr('string') declare state: string;

  get isActive() {
    return this.state === State.Active;
  }

  get retentionPeriod() {
    if (this.retentionDays < 120) {
      return this.intl.t(
        'apps.app.settings.security.conversation-auto-deletion.retention-period.day',
        { day: this.retentionDays },
      );
    } else {
      return this.humanizeDuration();
    }
  }

  humanizeDuration() {
    let daysLeft = this.retentionDays;

    let years = Math.floor(daysLeft / 365);
    daysLeft %= 365;

    let months = Math.floor(daysLeft / 30);
    daysLeft %= 30;

    let retention_period = '';
    if (years > 0) {
      retention_period += `${this.intl.t(
        'apps.app.settings.security.conversation-auto-deletion.retention-period.year',
        {
          year: years,
        },
      )} `;
    }

    if (months > 0) {
      retention_period += `${this.intl.t(
        'apps.app.settings.security.conversation-auto-deletion.retention-period.month',
        { month: months },
      )} `;
    }

    if (daysLeft > 0) {
      retention_period += this.intl.t(
        'apps.app.settings.security.conversation-auto-deletion.retention-period.day',
        { day: daysLeft },
      );
    }

    return retention_period;
  }
}
